import React from 'react';
import { roles } from '@nxsys/store/constants';

const ComingSoon = React.lazy(
  () => import('../../../modules/errorPages/ComingSoon'),
);

const AgencyPermissions = React.lazy(
  () => import('../../../modules/permissions/Agency'),
);

const CandidatesPermissions = React.lazy(
  () => import('../../../modules/permissions/Candidates'),
);

const CompanyPermissions = React.lazy(
  () => import('../../../modules/permissions/Company'),
);

const EmployeesPermissions = React.lazy(
  () => import('../../../modules/permissions/bureau/Employees'),
);

const bureauPermissionsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/permissions',
    element: <ComingSoon />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/permissions/company',
    element: <CompanyPermissions />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/permissions/employees',
    element: <EmployeesPermissions />,
  },
];

const umbrellaPermissionsConfig = [
  {
    permittedRole: [roles.admin],
    path: '/permissions',
    element: <ComingSoon />,
  },
  {
    permittedRole: [roles.admin],
    path: '/permissions/company',
    element: <CompanyPermissions />,
  },
  {
    permittedRole: [roles.admin],
    path: '/permissions/candidates',
    element: <CandidatesPermissions />,
  },
  {
    permittedRole: [roles.admin],
    path: '/permissions/agency',
    element: <AgencyPermissions />,
  },
];

export const permissionsConfig = (isBureau: boolean) => {
  if (isBureau) {
    return bureauPermissionsConfig;
  }
  return umbrellaPermissionsConfig;
};
